// extracted by mini-css-extract-plugin
export default {"row":"viewEvent_row__nroPe","col":"viewEvent_col__D7r6O","card":"viewEvent_card__59yBh"};